const REGION_LIST = ["Africa", "Americas", "Asia", "Europe", "Oceania"];

export default REGION_LIST;
